import * as React from 'react'

import theme from 'theme'

type CardContainerProps = React.HTMLAttributes<HTMLElement> & {
  showHoverEffect?: boolean
}

const CardContainer: React.FC<CardContainerProps> = ({
  showHoverEffect = true,
  ...rest
}) => {
  return (
    <article
      css={[
        {
          border: theme.border.base,
          borderRadius: theme.borderRadius[1],
          padding: theme.space[4],
          display: 'grid',
          gap: theme.space[3],
          position: 'relative'
        },
        showHoverEffect && {
          '&:hover, &:focus': {
            boxShadow: theme.boxShadows.medium,

            '.CardEllipsis': {
              visibility: 'visible',
              cursor: 'pointer'
            }
          }
        }
      ]}
      {...rest}
    />
  )
}

export default CardContainer
